import { useMemo } from 'react';
import { getLocalizedStr } from 'utils/LocaleUtil';
import useLocale from './useLocale';

export const useTextAreaMaxLength = (value: string, maxLength: number) => {
  const locale = useLocale();

  const isOverLimit = useMemo(() => {
    return (value.length ?? 0) > maxLength;
  }, [value.length, maxLength]);

  const charactersAvailableString = useMemo(
    () =>
      getLocalizedStr({
        string: locale.fields.charactersAvailable,
        replacements: { count: maxLength - (value?.length || 0) },
      }),
    [locale.fields.charactersAvailable, maxLength, value?.length],
  );

  return { maxLength, value, charactersAvailableString, isOverLimit };
};
